import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <div className="copyright">
          <p>© 2024 ELAY PROJECT SDN BHD. ALL RIGHTS RESERVED.</p>
          {/* External link remains anchor */}
          <a href="https://claviitech.com/" target="_blank" rel="noopener noreferrer">
            Powered by ClaviiTech
          </a>
        </div>
        <img className="footer-company-img" src="/images/general/ELAY-logo-white.png" alt="logo" />
        <div className="additional-links">
          <Link to="/termsofuse">TERMS OF USE</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 